/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment, PureComponent } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
import axios from "axios";

//import '../../css/event210621.css'

//import '../../css/event210926.css'

import { toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import { isMobile } from "react-device-detect";

class Event202204_pop extends PureComponent {
  state = {
    total: 0,
  };
  componentDidMount = () => {
    this._getData();
  };

  _getData = async () => {
    const result = await this._getDataApi();
    const intReturn = result.data[0].intReturn;
    const total = result.data[0].total;
    const list = result.data[0].listData;

    console.log(list);

    if (intReturn === 0) {
      this.setState({
        list,
        total,
      });

      //alert(list[0].title + '/' + list[1].title + '/' + list[0].idx + '/' + list[0].regDate)
    } else {
      toast.error("주문내역이 존재하지 않습니다.");
    }
  };

  _getDataApi = () => {
    const { apiUrl } = this.props;

    return axios.post(apiUrl + "/event_202204_list", {
      params: {},
    });
  };
  _close = () => {
    const { close } = this.props.childProps;
    close();
  };
  _renderItem = () => {
    const { list } = this.state;

    const lst = list.map((item, index) => {
      //console.log(item.grade[1])

      //console.log(this.total)
      return (
        <div className="item" key={index}>
          <div className="point">
            <span>현상금: {this._CommaFormatted(item.grade[1])} AP</span>
          </div>
          <a href="#">
            <img src={item.img} />
          </a>
        </div>
        /*
                <div style={{ color: '#fff'}} key={index}>
                    {item.title}
                </div>
                */
      );
    });

    return lst;
  };
  _go = () => {
    window.open("https://forms.gle/JAEv6sAg2rDkFgxd6", "", "");
  };
  _CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = "";
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = "," + (parseInt(str) % 1000) + "00" + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = "," + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ",0" + (parseInt(str) % 1000) + Money;
          else Money = ",00" + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };

  render() {
    const { list, total } = this.state;

    return (
      <Fragment>
        <div className="popup">
          <div className="popCont">
            <button type="button" className="pop_close" onClick={this._close}>
              <img src="/img/event/event220316/pop_close.png" />
            </button>
            <ul className="popContainer">
              <li className="tit">
                <span>
                  <small>NO.</small>
                  {list ? list[0].idx : null}
                </span>
                요원의 리워드 결과
              </li>

              <li className="form">
                <dl>
                  <dt>최종 수령금</dt>
                  <dd style={{ fontSize: 14 }}>
                    {this._CommaFormatted(total)}AP
                  </dd>
                </dl>
                <dl>
                  <dt>미션 수행일자</dt>
                  <dd style={{ fontSize: 14 }}>
                    {list ? list[0].regDate : null}
                  </dd>
                </dl>
              </li>
              <li className="list">{list ? this._renderItem() : null}</li>
            </ul>
            <div className="popLink">
              <a
                onClick={this._close}
                className="link"
                style={{ cursor: "pointer" }}
              >
                2분기 신작 라인업 확인하기
              </a>
              <a
                onClick={this._go}
                className="link"
                style={{ cursor: "pointer" }}
              >
                리워드 내역 인증샷 구글 폼 응모하기
              </a>
            </div>
            <img src="/img/event/event220316/pop_bg.png" />
          </div>
        </div>

        {/*
                <div>
                    <div onClick={this._close}>닫기</div>
                    { list ? this._renderItem() : null }
                </div>
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202204_pop));
